<template>
  <BaseFetchData :action="fetchData">
    <template #default="fetchDataProps">
      <div key="grid_view" class="p-4 space-y-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <FacebookPageInstagramPostCard v-for="post in posts" :key="post.id" :post="post" />
        </BaseGrid>
        <div v-if="fetchDataProps.status.loading" class="text-center">
          <Loader />
        </div>
        <div v-if="cursor" class="text-center">
          <BaseButton primary outline @click="fetchDataProps.fetchData({ after: cursor })"
            >Load More</BaseButton
          >
        </div>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { accountFacebookPageInstagramPostsClient } from '@/api/clients';
import FacebookPageInstagramPostCard from './FacebookPageInstagramPostCard.vue';

export default {
  components: {
    FacebookPageInstagramPostCard,
  },
  props: {
    facebookPage: {
      type: Object,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      posts: [],
      cursor: null,
    };
  },
  methods: {
    fetchData(params) {
      return accountFacebookPageInstagramPostsClient
        .list(this.accountId, this.facebookPage.id, {
          ...params,
          fields:
            'id,caption,comments_count,like_count,timestamp,username,media_product_type,media_type,owner,permalink,media_url,thumbnail_url',
          ...(this.since ? { since: this.since } : {}),
          ...(this.until ? { until: this.until } : {}),
        })
        .then((response) => {
          this.posts = [...this.posts, ...response.data];
          this.cursor = response.cursor;
        });
    },
    loadMore() {
      return this.fetchData({ after: this.cursor });
    },
  },
};
</script>
